import { Utility } from 'src/app/core/interceptor/utility';

export class Pagination<Type> {
  data: Type[] = [];
  page!: number;
  perPage!: number;
  totalPages!: number;
  totalRecords!: number;

  constructor(input: any = {}) {
    Object.assign(this, Utility.camelize(input));
  }
}
